import React from 'react';
import { Form } from '@ant-design/compatible';
import cx from 'classnames';
import Select from '../../input/Select';

const SelectForm = (props) => {
  const {
    className,
    form,
    label,
    rules,
    name,
    initialValue,
    onChange,
    isEditable = true,
    subContent,
    showInfo = true,
    vertical = false,
    validateTrigger = 'onChange',
    ...res
  } = props;
  const { getFieldDecorator } = form;

  return (
    <div className={cx(className)}>
      <Form.Item className={cx('select-form', 'amondz-form', { 'with-label': label }, { vertical })} label={label}>
        {getFieldDecorator(name, {
          rules,
          initialValue,
          onChange,
          validateTrigger,
        })(<Select isEditable={isEditable} {...res} />)}
      </Form.Item>

      {subContent && showInfo ? <div className="amondz-form-sub-content"> {subContent}</div> : null}
    </div>
  );
};

export default SelectForm;
